export default "__VITE_ASSET__DMdl8AkX__"